import React from "react";
import { Link } from "react-router-dom";
import "./ContinueExploringCategories.css";

import { productExploreCategories } from "../../../../data/productExploreCategories";

const ContinueExploringCategories = () => {
  return (
    <section
      className="continueExploring"
      aria-labelledby="continueExploring-heading"
    >
      <div className="continueExploring-inner">
        <div className="continueExploring-header">
          <h2 id="continueExploring-heading" className="continueExploring-title">
            Continue exploring
            <br />
            <span className="continueExploring-titleAccent">other categories</span>
          </h2>
        </div>

        <div className="continueExploring-grid">
          {productExploreCategories.map((item) => {
            const inner = (
              <>
                <div className="continueExploring-cardTop">
                  <div className="continueExploring-icon">
                    <img src={item.icon} alt="" draggable={false} />
                  </div>
                </div>
                <div className="continueExploring-cardBody">
                  <h3 className="continueExploring-cardTitle">{item.title}</h3>
                  <p className="continueExploring-cardDesc">{item.description}</p>
                </div>
              </>
            );

            return item.to ? (
              <Link className="continueExploring-card" key={item.title} to={item.to}>
                {inner}
              </Link>
            ) : (
              <div className="continueExploring-card" key={item.title}>
                {inner}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ContinueExploringCategories;
